export const nameRules = [
  {
    required: true,
    message: 'Party Name is mandatory'
  },
  {
    pattern: /[\p{L}\p{N}\p{M}]+/u,
    message: "Party Name can't have only space/special characters"
  }
];

export const partyKeyRules = [
  {
    pattern: /^[\p{L}\p{N}\p{M}]/u,
    message: "Party ID can't start with space/special characters"
  }
];

export const customerIdNoRules = [
  {
    pattern: /^[\p{L}\p{N}\p{M}]/u,
    message:
      "Customer Identification Number can't start with space/special characters"
  }
];

export const merchantRegistrationNumberRules = [
  {
    pattern: /^[\p{L}\p{N}\p{M}]/u,
    message:
      "Merchant Registration Number can't start with space/special characters"
  }
];

export const aliasRules = [
  {
    pattern: /^[\p{L}\p{N}\p{M}]/u,
    message: "Party Alias can't start with space/special characters"
  }
];

export const countryRules = [
  {
    pattern: /^[\p{L}\p{N}\p{M}]/u,
    message: "Country can't start with space/special characters"
  }
];

export const nationalityRules = [
  {
    pattern: /^[\p{L}\p{N}\p{M}]/u,
    message: "Nationality can't start with space/special characters"
  }
];

export const cityRules = [
  {
    pattern: /^[\p{L}\p{N}\p{M}]/u,
    message: "City can't start with space/special characters"
  }
];

export const zipRules = [
  {
    pattern: /^[^\p{L}]*$/u,
    message: "Zip/Postal Code can't have alphabets"
  },
  {
    pattern: /^[\p{L}\p{N}\p{M}]/u,
    message: "Zip/Postal Code can't start with space/special characters"
  }
];

export const addressRules = [
  {
    pattern: /[\p{L}\p{N}\p{M}]+/u,
    message: "Address can't have only space/special characters"
  }
];

export const prepareAlertHistoryFilters = (filters, jobId) => {
  const result = [];
  const { alertLevel } = filters;

  if (alertLevel) {
    result.push({
      columnName: 'alertLevel',
      logic: 'like',
      value: alertLevel
    });
  }

  if (jobId) {
    result.push({
      columnName: 'runInstanceExecutionId',
      logic: 'LIKE',
      value: jobId
    });
  }

  return result;
};
